import { useCallback } from 'react'

import { usePolling } from '@avantstay/backoffice-core'

import { arrivalModeColumnStore } from './ArrivalModeColumnStore'

export const useHomeStatusPolling = (
  homeIds?: string[],
  arrivalsMode?: boolean,
  interval = 30000,
) => {
  const fetchStatuses = useCallback(() => {
    return arrivalModeColumnStore.fetchHomeStatuses(homeIds, arrivalsMode)
  }, [homeIds, arrivalsMode])

  usePolling(fetchStatuses, interval, { pauseWhenHidden: true, maxRetries: 3 })
}
